import { omit } from '@/shared/utils/omit';

import { PersonalIdentifierDetails } from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsHelp,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type MilitaryIDGeneralFormType = PersonalIdentifierGeneralFormType;

export const MilitaryIDGeneralSection: MilitaryIDGeneralFormType = {
  ...commonGeneralFields,
};

export type MilitaryIDDetailsDto = Omit<
  PersonalIdentifierDetails,
  'createdAt' | 'updatedAt' | 'issuerCode' | 'basisForIssuingId'
>;

export type MilitaryIDDetailsHelp = Omit<
  PersonalIdentifierDetailsHelp,
  'issuerCode' | 'basisForIssuingId'
>;

export type MilitaryIDDetailsFormType = TDtoWrapper<MilitaryIDDetailsDto, MilitaryIDDetailsHelp>;

export const MilitaryIDDetailsSection: MilitaryIDDetailsFormType = {
  ...omit(commonDetailsFields, 'issuerCode', 'basisForIssuingId'),
};

export const MilitaryIDLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const MilitaryIDFormSections = [
  MilitaryIDGeneralSection,
  MilitaryIDDetailsSection,
  MilitaryIDLegalizedCopiesSection,
];
